import api from 'app/api'

export const userService = api.injectEndpoints({
  endpoints: (build) => {
    return {
      createUser: build.mutation({
        query: (args) => ({
          url: `user`,
          method: 'POST',
          body: args,
        }),
      }),
      getUserById: build.query({
        query: ({ id: userId }) => ({
          url: `user/${userId}`,
        }),
      }),
      getMyUser: build.query({
        query: () => ({
          url: `user/my/user`,
        }),
      }),
      updateUserById: build.mutation({
        query: ({ _id: userId, params }) => ({
          url: `user/${userId}`,
          method: 'PUT',
          body: params,
        }),
      }),

      getUsersByFullname: build.query({
        query: ({ searchText }) => ({ url: `user/list/search?searchText=${searchText}` }),
      }),
      
      
      getPaginatedUsers: build.query({
        query: (args) => {
          const { skip, take, sort, count, filter } = args
          return {
            url: `user/list/filter?$skip=${skip}&$take=${take}&$count=${count}&$filters=${encodeURIComponent(
              JSON.stringify(filter ?? {}),
            )}&$sort=${encodeURIComponent(JSON.stringify(sort ?? {}))}`,
            method: 'GET',
          }
        },
      }),
      deleteUser: build.mutation({
        query: (args) => ({
          url: `user/delete`,
          method: 'PUT',
          body: args,
        }),
        invalidatesTags: ['DELETE_USER'],
      }),
      updateUserPassword: build.mutation({
        query: (args) => ({
          url: `user/password`,
          method: 'PUT',
          body: args,
        }),
        invalidatesTags: ['UPDATE_USER'],
      }),
      updateUserStatus: build.mutation({
        query: (args) => ({
          url: `user/status`,
          method: 'PUT',
          body: args,
        }),
      }),
      updateUserArchive: build.mutation({
        query: ({ userId, isDeleted }) => ({
          url: `/user/${userId}/archive`,
          method: 'PUT',
          body: { isDeleted },
        }),
        invalidatesTags: ['UPDATE_USER_ARCHIVE'],
      }),
      updateUserFcm: build.mutation({
        query: ({ fcmToken }) => ({
          url: `/user/fcm`,
          method: 'PUT',
          body: { fcmToken },
        }),
        invalidatesTags: ['UPDATE_USER_FCM_TOKEN'],
      }),
      updateUserKvkkConsent: build.mutation({
        query: ({ isKvkkAccepted }) => ({
          url: `/user/kvkkconsent`,
          method: 'PUT',
          body: { isKvkkAccepted },
        }),
      }),
      updateUserByAdmin: build.mutation({
        query: ({ userId, teams = [], roles = [] }) => ({
          url: `/admin/user/update/${userId}`,
          method: 'PUT',
          body: { teams, roles },
        }),
      }),
      updateUserPasswordByAdmin: build.mutation({
        query: ({ userId, password }) => ({
          url: `/admin/user/password/${userId}`,
          method: 'PUT',
          body: { password },
        }),
        invalidatesTags: ['UPDATE_USER'],
      }),

    }
  },
})

export const {
  useUpdateUserByIdMutation,
  useCreateUserMutation,
  useLazyGetMyUserQuery,
  useLazyGetUserByIdQuery,
  useLazyGetUsersByFullnameQuery,
  useDeleteUserMutation,
  useUpdateUserPasswordMutation,
  useUpdateUserStatusMutation,
  useLazyGetPaginatedUsersQuery,
  useUpdateUserArchiveMutation,
  useUpdateUserFcmMutation,
  useUpdateUserKvkkConsentMutation,
  useUpdateUserByAdminMutation,
  useUpdateUserPasswordByAdminMutation
} = userService
